/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Ai_PolicyInputs */



/**
* | output |
* | --- |
* | "AI Principles" |
*
* @param {Footer_Ai_PolicyInputs} inputs
* @param {{ locale?: "nb-NO" | "en-GB" | "sv-SE" }} options
* @returns {LocalizedString}
*/
export const footer_ai_policy = /** @type {((inputs?: Footer_Ai_PolicyInputs, options?: { locale?: "nb-NO" | "en-GB" | "sv-SE" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Ai_PolicyInputs, { locale?: "nb-NO" | "en-GB" | "sv-SE" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-GB") return /** @type {LocalizedString} */ ("AI Principles")
	if (locale === "sv-SE") return /** @type {LocalizedString} */ ("AI-principer")
	return /** @type {LocalizedString} */ ("KI-prinsipper")
});